import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import DeliveryNotesTable from "./deliveryNotesTable";
import { setDeliveryNoteIsEdit, fetchAllDeliveryNotes } from "./redux/actions";
import { useDispatch, useSelector } from "react-redux";
import "./index.less";
import axios from "axios";
import { baseURL } from "../../globalUtils/axiosConfig";

const DeliveryNoteRegister = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { project_id } = useParams();
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(true); // Set to true for now, can be updated based on permissions later
  const [projectDetails, setProjectDetails] = useState(null);
  
  // Fetch project details when component mounts
  const fetchProjectDetails = async () => {
    if (!project_id) {
      return;
    }
    
    try {
      const res = await axios.get(`${baseURL}/project/${project_id}`);
      
      if (res.status === 200) {
        if (res.data && res.data.data) {
          setProjectDetails(res.data.data);
        } else if (res.data) {
          setProjectDetails(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  };

    useEffect(() => {
      if (project_id) {
        fetchProjectDetails();
      }
    }, [project_id]);

  return (
    <div className="page-top-div">
      <span className="text-span">DELIVERY NOTES FOR PROJECT {projectDetails?.projectNumber} - {projectDetails?.client}</span>
      <Row className="production-manager-parent-row card-container">
        <Col span={24} className="heading-col">
          <Row align="middle" gutter={[40, 0]}>
            <Col>
              <div>
                <span className="heading-span" style={{ color: "black" }}>DELIVERY NOTE REGISTER</span>
              </div>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <DeliveryNotesTable canUpdate={canUpdate} />
        </Col>
      </Row>
    </div>
  );
};

export default DeliveryNoteRegister;
